import React, { useEffect, useState } from "react";
import { useUserData } from "hooks/UserContext";
import { clientesApi } from "page/OrderResumePag/_services/api";
import { useParams } from "react-router";
import { getCustomerFromMemory, setCustomerInMemory } from "lib/sharedSessionMemory";

export default function ResumoHotel() {
  const { uuid } = useParams();
  const [iframeUrl, setIframeUrl] = useState(null);
  const [error, setError] = useState(null);
  const { user, setUserData, setUser } = useUserData();

  useEffect(() => {
    try {
      if (!user || !user.balance) return;

      const balance = user?.balance?.data ?? 0;
      const userUuid = user?.uuid;

      if (!userUuid) {
        setError("Sessão inválida — usuário não autenticado.");
        return;
      }

      const baseUrl = process.env.REACT_APP_MONOLITO_URL;
      const channel = process.env.REACT_APP_DEFAULT_CHANNEL;
      const fullUrl = `${baseUrl}/${channel}/resumo-hotel?uuid=${uuid}&balance=${balance}`;

      setIframeUrl(fullUrl);
    } catch (err) {
      console.error("Erro ao montar iframe:", err);
      setError("Erro interno ao carregar o conteúdo.");
    }
  }, [user?.uuid]);

  if (error) {
    return (
      <div style={{ textAlign: "center", marginTop: "100px", color: "red" }}>
        {error}
      </div>
    );
  }

  if (!iframeUrl) {
    return <p style={{ textAlign: "center", marginTop: "100px" }}>Carregando...</p>;
  }

  const updateUserDataEvent = async () => {
    const userData = getCustomerFromMemory();

    const balance = await clientesApi.get(
      `customer/${userData.data.cpf}/balance`
    );

    if (userData) {
      userData.data.balance = {
        data: balance.data.data
      };
      setCustomerInMemory(userData);

      setUserData(userData);
      setUser(userData.data);
    }
  }
    
  window.addEventListener('message', (event) => {
    const data = event.data;
    if (data?.type === 'UPDATE_USER_DATA') {
      updateUserDataEvent(); 
    }
  });

  return (
    <div style={{ width: "100%", height: "100vh", overflow: "hidden" }}>
      <iframe
        src={iframeUrl}
        title="Resumo do Hotel"
        style={{
          width: "100%",
          height: "80%",
          border: "none",
          overflow: "hidden",
          marginTop: "35%"
        }}
      />
    </div>
  );
}